<template>
  <div class="rounded my-auto mb-3">
    <div
      :class="[
        'block',
        'text-sm',
        'text-gray-900',
        'hover:text-gray-900',
        'hover:bg-gray-100',
        'focus:outline-none',
        'shadow',
        'my-2',
        'overflow-hidden',
        'border-t',
        'border-b',
        'border-orange-600',
        focused ? 'bg-orange-200' : 'bg-white',
        starting ? 'rounded-l' : 'rounded-r',
        starting ? 'border-l-4' : 'border-r-4',
      ]"
      @click="clickAction"
    >
      <div class="p-2">
        <p class="text-xs" :class="[focused ? 'text-orange-600' : 'text-gray-600']">
          {{ campaign.name }}
        </p>
        <span
          v-if="campaign.totalActiveChannels > 0"
          class="inline-block text-orange-600 text-xs font-medium bg-orange-200 rounded-full px-3 leading-6 mt-2"
        >
          Active
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'CampaignCard',

  props: {
    day: {
      type: Object,
      required: true,
    },
    campaign: {
      type: Object,
      required: true,
    },
    focused: Boolean,
    starting: Boolean,
  },

  computed: {
    ...mapState('entities', {
      project({ projects }) {
        if (!this.campaign.projectUuid) return null;
        return projects.byId[this.campaign.projectUuid] || null;
      },
    }),
  },

  methods: {
    clickAction() {
      const { currentRoute } = this.$router;

      this.$router.replace({
        name: currentRoute.name,
        params: { ...currentRoute.params },
        query: {
          ...currentRoute.query,
          editCampaign: this.campaign.id,
          campaignId: this.campaign.id,
          tab: 'schedule',
        },
      });
    },
  },
};
</script>
